import React from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

import { NewsletterProps } from '@components/pages/Article/interfaces';

import SubscribeToNewsletter from '../SubscribeToNewsletter';

const props: NewsletterProps = {
  description:
    'We unpack the fast-changing world of cryptocurrency and blockchain and delve into how digital money is reshaping tech and finance from Silicon Valley to Wall Street to Asia.',
  frequency: 'Weekly',
  id: 13,
  isSubscribed: false,
  name: 'Crypto Global',
};

const subscribedProps: NewsletterProps = {
  description:
    'Follow the reporters and editors who break and shape the news through The Information Newsletters.',
  frequency: 'Newsletters',
  id: props.id,
  isSubscribed: true,
  name: 'The Information Newsletters',
};

const queryClient = new QueryClient();

describe('<SubscribeToNewsletter />', () => {
  it('renders unsubscribed variant', () => {
    const { getByRole, getByTestId, getByText } = global.render(
      <QueryClientProvider client={queryClient}>
        <SubscribeToNewsletter {...props} />
      </QueryClientProvider>
    );

    expect(getByTestId('newsletter-article')).toBeInTheDocument();
    expect(getByText(props.frequency)).toBeInTheDocument();
    expect(getByText(props.name)).toBeInTheDocument();
    expect(getByText(props.description)).toBeInTheDocument();
    expect(getByRole('button', { name: /Subscribe now/ })).toBeInTheDocument();
  });

  it('renders subscribed variant', () => {
    const { getByRole, getByTestId, getByText } = global.render(
      <QueryClientProvider client={queryClient}>
        <SubscribeToNewsletter {...subscribedProps} />
      </QueryClientProvider>
    );

    expect(getByTestId('newsletter-article')).toBeInTheDocument();
    expect(getByText(subscribedProps.frequency)).toBeInTheDocument();
    expect(getByText(subscribedProps.name)).toBeInTheDocument();
    expect(getByText(subscribedProps.description)).toBeInTheDocument();
    expect(getByRole('link', { name: /View list/ })).toBeInTheDocument();
  });

  it('subscribes successfully', () => {
    const { getByRole, getByTestId } = global.render(
      <QueryClientProvider client={queryClient}>
        <SubscribeToNewsletter {...props} />
      </QueryClientProvider>
    );

    expect(getByTestId('newsletter-article')).toBeInTheDocument();
    const subscribeButton = getByRole('button', { name: /Subscribe now/ });
    expect(subscribeButton).toBeInTheDocument();
    expect(subscribeButton).not.toHaveAttribute('disabled');

    global.waitFor(() => {
      global.fireEvent.click(subscribeButton);
    });
    expect(subscribeButton).toHaveAttribute('disabled');
    expect(getByRole('button', { name: /Subscribed/ })).toBeInTheDocument();
  });
});
